<template>
  <PageTemplate alternative>
    <Header mod="vaccine" />
    <Banner mod="vaccine" />
    <ScheduleVaccines :colors="['#CA918F', '#F8EDED']" mod="vaccine" />
    <Structure mod="vaccine" />
    <Videos mod="vaccine" color="#CA918F" />
    <BannerBottom mod="vaccine" />
    <AvailableVaccines mod="vaccine" color="#CA918F" />
    <TeamVaccine :colors="['#CA918F', '#F0E0DF', '#B6757E']" mod="vaccine" />
    <Footer mod="vaccine" logo="/img/vaccine-footer.png" />
  </PageTemplate>
</template>

<script>
import PageTemplate from "../../templates/Page.vue";
import Header from "../../shell/PagesHeader.vue";
import Banner from "../../templates/Banner.vue";
import BannerBottom from "../../templates/BannerBottom.vue";
import Structure from "../../templates/Structure.vue";
import Videos from "../../templates/Videos.vue";
import TeamVaccine from "../../templates/TeamVaccine.vue";
import AvailableVaccines from "../../templates/AvailableVaccines.vue";
import ScheduleVaccines from "../../templates/ScheduleVaccines.vue";
import Footer from "../../shell/PagesFooter.vue";

export default {
  components: {
    PageTemplate,
    Header,
    Banner,
    BannerBottom,
    Videos,
    Structure,
    TeamVaccine,
    Footer,
    AvailableVaccines,
    ScheduleVaccines,
  },
};
</script>
